export const KeysLocalStorage: Record<string, string> = {
  lastLocal: 'last_local',
  lastProjectId: 'last_project_id',
  activeCommonThemeId: 'active_common_theme_id',
};
